import { BaseResponse } from './_base';

interface IntegrationState {
  active: boolean;
}

export interface GetActivationStatusResponse extends BaseResponse {
  status: IntegrationState;
}

export enum Affiliate {
  BEYONDPRICING = 'beyondpricing',
  DPGO = 'dpgo',
  HOSTFULLY = 'hostfully',
  MATTERPORT = 'matterport',
  NIGHTPRICER = 'nightpricer',
  PAYPAL = 'paypal',
  PERFECT_PRICE = 'perfect_price',
  PRICELABS = 'pricelabs',
  QUIBBLE = 'quibble',
  RENTED = 'rented',
  TRUPLACE = 'truplace',
  TURBOSUITE = 'turbosuite',
  WHEELHOUSE = 'wheelhouse',
}

export interface IntegrationSettings {
  affiliateEnum: Affiliate;
  isEnabled: boolean;
  agencyUid: string;
  token?: string;
  readOnlyIntegrationSettings?: {
    enableReadOnlyAccessForAllProperties: boolean;
  };
}

export interface GetIntegrationSettingsResponseTO {
  integrationSettings: IntegrationSettings[];
  metadata: {
    count: number;
  };
}
